/* eslint-disable @typescript-eslint/no-use-before-define */
import {
  breakpoints,
  Button,
  Paragraph,
  Select,
  Space,
  Text,
} from 'components';
import React, { useContext } from 'react';
import styled from 'styled-components';
import AppointmentBookingInternalContext from '../AppointmentBookingInternalContext';
import { OVERRIDE_OPTIONS } from './constants';
import type { OverrideOptionType } from './types';

const AgentOverrideOverlay: React.FC<{ listingStatus: string }> = ({
  listingStatus,
}) => {
  const { setOverrideShowingType } = useContext(
    AppointmentBookingInternalContext,
  );
  const [selectedOption, setSelectedOption] =
    React.useState<OverrideOptionType | null>(null);

  return (
    <StyledSpace direction="vertical">
      <Paragraph>
        This property is currently not accepting online showings.
        <Paragraph>Listing Status: {listingStatus}</Paragraph>
      </Paragraph>
      <Paragraph>
        If you were involved in this transaction representing the buyers and are
        required to gain access to the property, please select from one of the
        following reasons.
      </Paragraph>
      <div>
        <StyledLabel type="secondary">Reason for showing request:</StyledLabel>
        <StyledSelect
          value={selectedOption}
          options={OVERRIDE_OPTIONS}
          labelInValue
          onChange={(option: (typeof OVERRIDE_OPTIONS)[number]) => {
            setSelectedOption(option.value);
          }}
          style={{ maxWidth: breakpoints.sm, marginBottom: 5 }}
        />
      </div>
      <StyledButton
        type="primary"
        onClick={() => setOverrideShowingType(selectedOption!)}
        disabled={!selectedOption}
      >
        Continue
      </StyledButton>
    </StyledSpace>
  );
};

const StyledSelect = styled(Select)`
  max-width: ${breakpoints.sm};
  margin-bottom: 5px;
`;

const StyledLabel = styled(Text)`
  display: block;
  margin-bottom: 5px;
`;

const StyledButton = styled(Button)`
  // 👇🏼 default antd styles that are overridden by angular style sheets, that we have to override them back 🤷🏼‍♂️
  &&& {
    color: #fff;
    :disabled {
      color: rgba(0, 0, 0, 0.25);
      cursor: not-allowed;
    }
  }
`;

const StyledSpace = styled(Space)`
  max-width: 720px;
  margin-left: 25px;
  margin-top: 15px;
  font-size: 14px;
`;

export default AgentOverrideOverlay;
